import { useState } from 'react';
import initFilters from './constants/initFiltering';

const useCustomHook = () => {
  const [filters, setFilters] = useState(initFilters());
  const [openDialog, setOpenDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);

  return {
    filters,
    setFilters,
    openDialog,
    setOpenDialog,
    loading,
    setLoading,
    setFilterParams,
    size,
    setSize,
    page,
    setPage,
  };
};

export default useCustomHook;
